import React, { useRef } from 'react';
import { useScrollAppear } from './useScrollAppear';
import { useForkRef } from '../../hooks/useForkRef';
import { StickyCompat } from './StickyCompat';
/**
 * The compatibility component for older versions of Sticky, with the scroll-to-
 * appear feature.
 * @deprecated Please convert this to Sticky, as this is only provided for
 *   compatibility reasons.
 */
export function ScrollStickyCompat(props) {
    const { innerRef, offset, threshold, initialHeight, ...restProps } = props;
    const childStickyRef = useRef(null);
    const childForkRef = useForkRef(innerRef, childStickyRef);
    const offsets = useScrollAppear(childStickyRef, { offset, threshold, initialHeight });
    return (React.createElement(StickyCompat, Object.assign({}, restProps, offsets, { innerRef: childForkRef })));
}
//# sourceMappingURL=ScrollStickyCompat.js.map